import styled from "styled-components";

const Button = styled.button`
  width: 24px;
  height: 24px;
  padding: 0%;
  background-color: transparent;
  border: none;
  cursor: pointer;
`;

export const S = { Button };
